// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YnJw","tabsBox":"styles_tabsBox__zg8nj","createButton":"styles_createButton__1C80h"};